<div class="container">
  <div></div>
  <div class={{classHtml}}>{{frase01}}</div>
  <div class={{classHtml}}>{{frase02}}</div>
  <div class={{classHtml}}>{{frase03}}</div>
  <div class="mat-progress-bar"><mat-progress-bar mode="indeterminate"></mat-progress-bar></div>
</div>
